import type {BackendChatSession, ChatSession} from "~/pages/chat-agent/types/chatTypes";

export function mapBackendSession(bs: BackendChatSession): ChatSession {
    return {
        id: bs.session_id,
        userId: bs.user_id,
        name: bs.display_name || 'New chat',
        messages: [],
        created_at: new Date(bs.last_update_time),
        updated_at: new Date(bs.last_update_time),
        appName: bs.app_name,
        dashboard: bs.dashboard ?? null,
    };
}

/**
 * Overlays fresh server rows on the local sessions. Loaded messages survive the refresh; sessions the
 * server doesn't know yet are kept first.
 */
export function mergeServerSessions(local: ChatSession[], server: ChatSession[]): ChatSession[] {
    const localById = new Map(local.map((s) => [s.id, s] as const));
    const serverIds = new Set(server.map((s) => s.id));
    const mergedServer = server.map((fs) => {
        const existing = localById.get(fs.id);
        return existing ? {...existing, ...fs, messages: existing.messages} : fs;
    });
    const localOnly = local.filter((s) => !serverIds.has(s.id));
    return localOnly.length ? [...localOnly, ...mergedServer] : mergedServer;
}
